(function(){
    // Swiper default setting ************************************************
    let defaulsettings = {
        loop: true,
        speed: 900,
        effect: 'fade',
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
    };

    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    // Reviews Shortcode *******************

    let main_swiper_reviews = new Swiper(".mainSwiper_reviews", {
        rewind:true,
        speed: 900,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination_reviews",
            clickable: true
        }
    });


    // Slider Shortcode *******************

    let main_swiper_slider = new Swiper(".mainSwiper_slider", {
        loop:true,
        speed: 900,
        slidesPerView: 1.2,
        autoplay: {
            delay: 5500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination_slider",
            clickable: true
        },
    });

    // Slider Rooms Shortcode *******************

    let main_swiper_rooms = new Swiper(".mainSwiper_rooms", {
        rewind:true,
        speed: 900,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let other_swiper_rooms = new Swiper(".swiperControlled_rooms", {
        speed: 900,
        rewind:true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination_rooms",
            clickable: true

        }
    })

    main_swiper_rooms.controller.control = other_swiper_rooms;
    other_swiper_rooms.controller.control = main_swiper_rooms;

    // Singlequad Shortcode *******************

    let main_swiper_singlequad = new Swiper(".swiper_singlequad", {
        rewind:true,
        speed: 900,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination__singlequad",
            clickable: true

        }
    });

    // Gallery Shortcode *******************

    let main_swiper_gallery = new Swiper(".mainSwiper_gallery", {
        rewind:true,
        speed: 900,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let other_swiper_gallery = new Swiper(".swiperControlled_gallery", {
        rewind:true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination_gallery",
            clickable: true

        }
    })
    let other_swiper_2_gallery = new Swiper(".swiperControlled_2_gallery", {
        rewind:true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    })

    main_swiper_gallery.controller.control = [other_swiper_gallery, other_swiper_2_gallery];
    other_swiper_gallery.controller.control = main_swiper_gallery;
    other_swiper_2_gallery.controller.control = main_swiper_gallery;


     // Gallery Shortcode Mobile *******************

     let gallery_mobile_swiper = new Swiper(".slider_mobile", {
        centeredSlides: true,
        slidesPerView: 1.5,
        spaceBetween: 10,
        loop:true,
        pagination: {
            el: ".swiper-pagination_gallery_mobile",
            clickable: true
        }
    });
    
})();


